export const CONTENT_OBJECT_TYPE_ID: { [key: string]: number } = {
    None: 0,
    Exam: 1,
    MiniDiagnostic: 2,
    ExamAdaptiveSections: 3,
    SubjectExam: 4,
    Articulate: 10,
    DrillUnique: 11,
    Drill: 12,
    DrillAdaptive: 13,
    PairedDrill: 14,
    OfflineReading: 15,
    OfflineDrill: 16,
    Video: 17,
    AmplifirePrimer: 18,
    AmplifireModule: 19,
    AAMC: 20,
    Feedback: 21,
    Survey: 22,
    Xyleme: 23,
    AdaptiveSetup: 24,
    DrillAdaptiveSetup: 25
}